import { render } from "./Form4.vue?vue&type=template&id=44ba9d5c&scoped=true"
import script from "./Form4.vue?vue&type=script&lang=js"
export * from "./Form4.vue?vue&type=script&lang=js"

import "./Form4.vue?vue&type=style&index=0&id=44ba9d5c&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ba9d5c"]])

export default __exports__